import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { ResourceFormValues } from "src/models/Resource.model";
import ResourceForm from "../Layouts/ResourceForm";
import {
  useEditResourceMutation,
  useGetResourceByIdQuery,
} from "src/services/ResourceServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedId: any;
};

const EditResourceFormWrapper = ({ onClose, selectedId }: Props) => {
  const [resourceData, setResourceData] = useState<any>({});

  const { data, isFetching, isLoading } = useGetResourceByIdQuery(selectedId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setResourceData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  const [editResource] = useEditResourceMutation();

  // Form Initial Values
  const initialValues: ResourceFormValues = {
    resourceType: {
      label: resourceData?.type,
      value: resourceData?.type,
    },
    imageUrl: resourceData?.imageUrl || "",
    dataDescription: resourceData?.description || "",
    title: resourceData?.title || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    resourceType: object().required("Please enter name"),
    title: string().required("Please enter title "),
  });

  // Handle Submit
  const handleSubmit = (
    values: ResourceFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ResourceFormValues>
  ) => {
    const formattedValues = {
      title: values?.title,
      description: values?.dataDescription,
      imageUrl: values?.imageUrl,
      type: values?.resourceType?.value,
    };

    editResource({
      body: formattedValues,
      id: selectedId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {isLoading && isFetching && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ResourceForm formikProps={formikProps} onClose={onClose} formType='UPDATE' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditResourceFormWrapper;
